import { useNavigate } from "@tanstack/react-router";
import { useViewMode } from "@stores/usePortalModeStore";
import { CourseOverviewTarget } from "./store";

export function useCourseNavigation() {
    const viewMode = useViewMode();
    const navigate = useNavigate();
    return (target: CourseOverviewTarget) => {
        if (viewMode !== "staff") return;

        if (target.type === "class") {
            void navigate({ to: "/groups/classes/$classId", params: { classId: target.id } });
        } else {
            void navigate({ to: "/groups/course/$courseId", params: { courseId: target.id } });
        }
    };
}

export function useCourseNavigationEnabled() {
    return useViewMode() === "staff";
}
